import Vue from "vue";
export default {
  mounted() {
    this.$emit("input", {
      getValue: this.getValue,
      getValues: this.getValues,
      setValue: this.setValue,
      setValues: this.setValues,
      hidden: this.hidden,
      disabled: this.disabled,
      setOptions: this.setOptions,
      resetFields: this.resetFields,
      validate: this.validate,
      validateField: this.validateField,
      clearValidate: this.clearValidate,
      setProps: this.setProps,
      visible: this.visible,
      setValidate: this.setValidate,
    });
  },
  methods: {
    getValues(fields = []) {
      if (fields.length > 0) {
        const values = {};
        fields.forEach((field) => {
          values[field] = this.formData[field];
        });
        return values;
      } else {
        return this.formData;
      }
    },
    getValue(field) {
      return this.formData[field];
    },
    setValues(obj) {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
          this.formData[key] = obj[key];
        }
      }
    },
    setValue(field, value) {
      this.formData[field] = value;
    },
    hidden(flag, field) {
      const rule = this.ruleList.find((item) => {
        return item.field === field;
      });
      if (rule) {
        Vue.set(rule, "hidden", flag);
      }
    },
    visible(flag, field) {
      const rule = this.ruleList.find((item) => {
        return item.field === field;
      });
      if (rule) {
        Vue.set(rule, "visible", flag);
      }
    },
    setOptions(options, field) {
      const rule = this.ruleList.find((item) => {
        return item.field === field;
      });
      if (rule) {
        Vue.set(rule, "options", options);
      }
    },
    disabled(flag, field) {
      const rule = this.ruleList.find((item) => {
        return item.field === field;
      });
      if (rule) {
        if (rule.props === undefined) {
          Vue.set(rule, "props", {});
        }
        Vue.set(rule.props, "disabled", flag);
      }
    },
    resetFields() {
      this.$refs.form.resetFields();
    },
    validate(callback) {
      return this.$refs.form.validate(callback);
    },
    validateField(fields, callback) {
      return this.$refs.form.validateField(fields, callback);
    },
    clearValidate(fields) {
      this.$refs.form.clearValidate(fields);
    },
    setProps(field, key, value) {
      const rule = this.ruleList.find((item) => {
        return item.field === field;
      });
      if (rule) {
        if (rule.props === undefined) {
          Vue.set(rule, "props", {});
        }
        Vue.set(rule.props, key, value);
      }
    },
    setValidate(field, validate) {
      const rule = this.ruleList.find((item) => {
        return item.field === field;
      });
      if (rule) {
        Vue.set(rule, "validate", validate);
      }
    },
  },
};
